import { fetchDealsLogic } from './fetchDealsLogic';

export const logic = [fetchDealsLogic];
